<template>
  <div class="space-y-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Total Mínimo de Compra *
      </label>
      <div class="relative">
        <span class="absolute left-3 top-2 text-gray-500 dark:text-gray-400">$</span>
        <input 
          :value="modelValue.min_order_total" 
          type="number"
          min="0" 
          step="0.01" 
          required
          class="w-full pl-8 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
          placeholder="0.00"
          @input="updateField('min_order_total', $event)" 
        >
      </div>
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Costo de Envío si el total es mayor o igual *
      </label>
      <div class="relative">
        <span class="absolute left-3 top-2 text-gray-500 dark:text-gray-400">$</span>
        <input 
          :value="modelValue.fee_above_threshold" 
          type="number"
          min="0" 
          step="0.01"
          required 
          class="w-full pl-8 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
          placeholder="0.00"
          @input="updateField('fee_above_threshold', $event)" 
        >
      </div>
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Costo de Envío si el total es menor *
      </label>
      <div class="relative">
        <span class="absolute left-3 top-2 text-gray-500 dark:text-gray-400">$</span>
        <input 
          :value="modelValue.fee_below_threshold" 
          type="number"
          min="0" 
          step="0.01"
          required 
          class="w-full pl-8 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
          placeholder="0.00"
          @input="updateField('fee_below_threshold', $event)" 
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  modelValue: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'update:modelValue': [value: Record<string, any>]
}>()

const updateField = (field: string, event: Event) => {
  const target = event.target as HTMLInputElement
  const numValue = parseFloat(target.value) || 0
  emit('update:modelValue', {
    ...props.modelValue,
    [field]: numValue
  })
}
</script>
